import { merge } from 'lodash';
import type {
  MapLayer,
  VectorLayerZone,
  VectorLayerZoneStyle,
  VectorLayerZoneStyleData,
  VectorMapLayer
} from '@common';
import { useMap, MapCalculationMode, generateFeatureStyle } from '@common';
import type { Map } from '@common';

export const parcelYearMapInfoSubTitleFn = (layer: MapLayer, t: (key: string) => string) => {
  const parcelName = layer.group?.customData.parcelName;
  const year = layer.group?.customData.year;
  if (layer.group?.map) {
    const { calculationMode } = useMap(layer.group?.map as Map);

    if (calculationMode.value === MapCalculationMode.ISOLATED) {
      return year ? `${parcelName} (${year})` : parcelName;
    }
  }

  return t('map.summarized');
};

export const adviceLabelZoneLabelFn = (_: VectorMapLayer, zone: VectorLayerZone) => {
  return zone.customData?.label !== undefined ? `${zone.customData.label}` : '';
};

export const adviceZoneStyleFn = async (layer: VectorMapLayer) => {
  const result: VectorLayerZoneStyleData[] = [];
  const colorMap = layer.data.colorMap;

  if (colorMap) {
    layer.data.zones.forEach((zone) => {
      const styleConfig: Partial<VectorLayerZoneStyle> = merge(layer.data.zoneStyleConfig.defaultStyle, {
        color: colorMap.colors[zone.value] || '#000000',
        strokeColor: colorMap.strokeColor
      });

      const defaultStyle = generateFeatureStyle(styleConfig, layer.data.zoneLabelFn(layer, zone));

      result.push({
        defaultStyle,
        selectedStyle: defaultStyle
      });
    });
  } else {
    layer.data.zones.forEach((zone) => {
      result.push({
        defaultStyle: generateFeatureStyle(
          layer.data.zoneStyleConfig.defaultStyle,
          layer.data.zoneLabelFn(layer, zone)
        ),
        selectedStyle: generateFeatureStyle(
          layer.data.zoneStyleConfig.selectedStyle,
          layer.data.zoneLabelFn(layer, zone)
        )
      });
    });
  }

  return result;
};

export const handleDevidedLayoutChange = (
  switchLayout: (layerName: string) => void,
  devided: boolean,
  mapsOrientation?: 'horizontal' | 'vertical'
) => {
  if (!devided || !mapsOrientation) {
    switchLayout('1');
  } else {
    const selectedLayout = mapsOrientation === 'vertical' ? '2' : '3';
    switchLayout(selectedLayout);
  }
};
